import React, { useState } from "react";
import Dock from "react-dock";

import "./BreadcrumbsOptions.scss";
import FolderDetails from "../../FolderDetailsView/FolderDetailsView";
import CreateNewFolder from "../../CreateNewFolder/CreateNewFolder";
import InfoIcon from "../../../assets/icons/info.svg";
import Dropdown from "../../UI/DropDown/DropDown";
import { Route, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { mapStateToProps } from "../../../common/UserDataReducer";
import ShareModal from "../../ShareModal/ShareModal";
import ArchiveConfirmationModal from "../../Files/ArchiveConfirmationModal/ArchiveConfirmationModal";
import { apolloClient } from "../../..";
import { gql } from "@apollo/client";
import { notify } from "../../Notify/Notify";
import { CREATE_SUBFOLDER } from "../../../constants/workspaces";

const BreadcrumbsOptions = (props) => {
  const [visible, setVisible] = useState(false);
  const [shared, setShared] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [archiveItemName, setArchiveItemName] = useState(undefined);
  const [archiveItemId, setArchiveItemId] = useState("");
  const [dockSize, setDockSize] = useState(0.4);

  function dockHandler() {
    setVisible(!visible);
  }

  const shareToggle = (share) => {
    setShared(!shared);
    props.setShareFolder(share);
  };

  const setShare = () => {
    setShared(!shared);
  };

  const setArchiveModalVisibility = (
    show,
    itemName = undefined,
    itemId = ""
  ) => {
    setShowArchiveModal(show);
    setArchiveItemName(itemName);
    setArchiveItemId(itemId);
  };

  const archiveFolder = (date) => {
    const totalDays = props.getTotalDays(date);
    const variables = {
      folders: [archiveItemId],
      archivedTill: totalDays,
    };
    apolloClient
      .mutate({
        mutation: gql`
          mutation ArchiveFolders($folders: [UUID], $archivedTill: Int!) {
            archiveFolders(folders: $folders, archivedTill: $archivedTill) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        setShowArchiveModal(false);
        props.onArchiveItem(props.folder[0]);
        const detail = "Success";
        const title = `${archiveItemName} archived successfully!`;
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  const getContentRole = (userRoleId) => {
    const folder = props.folder[0];
    if (userRoleId === 1 || userRoleId === 2) {
      return [true, { role: "Owner" }];
    } else if (folder) {
      const createUserId = folder.createdBy.id;
      const logUserId = props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = [true, { role: "Owner" }];
      } else {
        const sharedUsers = folder.sharedFolder.map((sharedItem) => {
          return {
            id: sharedItem.user.id,
            role: sharedItem.userRole.name,
          };
        });
        const getAccess = sharedUsers.find(
          (sharedUser) =>
            sharedUser.id === logUserId &&
            (sharedUser.role === "Owner" || sharedUser.role === "Collaborator")
        );
        returnedVal = getAccess ? [true, getAccess] : [false];
      }
      return returnedVal;
    }
  };
  return (
    <div className="d-flex breadcrumbs-options">
      <div className="pr-4 d-flex">
        <img
          className="info-button"
          src={InfoIcon}
          alt="InfoIcon"
          onClick={dockHandler}
        />
      </div>
      <div className="custom-dock">
        <Dock
          position="right"
          dimMode="none"
          isVisible={visible}
          size={dockSize}
          defaultSize={0.4}
          onSizeChange={(size) => {
            return size > 0.4 && size < 0.7 ? setDockSize(size) : null;
          }}
        >
          {props.folder.length > 0 && (
            <FolderDetails
              folderDetails={props.folder[0]}
              folderSharedWith={props.folder.sharedWith}
              itemsCount={props.itemsCount}
              dockHandler={dockHandler}
              shared={shared}
              shareToggle={(share) => shareToggle(share)}
              {...props}
            />
          )}
        </Dock>
      </div>
      {props.isFolderView &&
      props.itemsCount > 0 &&
      getContentRole(props.userRoleId) &&
      getContentRole(props.userRoleId)[0] ? (
        <button
          type="button"
          className="btn-secondary mr-4"
          data-toggle="modal"
          data-target="#MyModal1"
          onClick={() => {
            props.setEditFolder(false, {});
          }}
        >
          {CREATE_SUBFOLDER}
        </button>
      ) : null}
      {props.folder.length > 0 && (
        <CreateNewFolder
          allRootFolders={props.folder}
          doNotShowRootOption={true}
          onNewFolderAdded={props.onNewFolderAdded}
          onFolderUpdated={props.onFolderUpdated}
          editFolder={props.editFolder}
          updateFolder={props.updateFolder}
          createSubFolder={true}
          {...props}
        />
      )}
      <ShareModal
        currentUserInfo={props.currentUserInfo}
        showShareModal={props.showShareModal}
        handleShareModal={props.handleShareModal}
        shareFolder={props.shareFolder}
        type={props.type}
        setShareFolders={props.setShareFolders}
        totalCheck={props.totalCheck}
        checkedShareFolder={props.checkedShareFolder}
        setDocumentsSharedWith={props.setDocumentsSharedWith}
        setShare={setShare}
        subFolders={props.subFolders}
        rootFolders={props.rootFolders}
        updateFolders={props.updateFolders}
        documents={props.documents}
        updateDocuments={props.updateDocuments}
        match={props.match}
        shareMultipleDocument={props.shareMultipleDocument}
      />
      <Route
        path="/files/:folderId/:subId"
        render={() => (
          <NavLink
            to={"/files/".concat(
              props.match.params.folderId,
              "/",
              props.match.params.subId,
              "/bulk-upload"
            )}
          >
            {props.itemsCount > 0 &&
              getContentRole(props.userRoleId) &&
              getContentRole(props.userRoleId)[0] && (
                <button className="btn btn-primary d-flex">
                  Add File
                  {/* <img className="down-arrow pl-2" src={DownArrow} alt="DownArrow" /> */}
                </button>
              )}
          </NavLink>
        )}
      />
      {getContentRole(props.userRoleId) &&
      getContentRole(props.userRoleId)[0] ? (
        <div className="breadcrumb-dropdown ml-4">
          <Dropdown
            contentAccess={getContentRole(props.userRoleId)[1]}
            handleEdit={(e) => {
              e.preventDefault();
              const isRootFile = props.folder[0].parentFolder;
              props.setEditFolder(
                true,
                props.folder[0],
                isRootFile === null ? false : true
              );
            }}
            handleShare={(e) => {
              e.preventDefault();
              props.setShareFolder(props.folder[0]);
            }}
            handleArchive={(e) => {
              e.preventDefault();
              const folder = props.folder[0];
              setArchiveModalVisibility(true, folder.title, folder.id);
            }}
          />
        </div>
      ) : null}
      <ArchiveConfirmationModal
        showModal={showArchiveModal}
        archiveItemName={archiveItemName}
        handleYesClick={(date) => {
          archiveFolder(date);
        }}
        handleNoClick={() => {
          setArchiveModalVisibility(false);
        }}
      />
    </div>
  );
};

export default connect(mapStateToProps)(BreadcrumbsOptions);
